module.exports = __webpack_public_path__ + "img/django-svgrepo-com.e6e3f5dc.svg";